import React from 'react'
import style from './style.module.css'
import LinkExpired from '../../../../assets/Timeout.png'
import { APP_NAME } from '../../../../constants/app'
export const TokenExpired = () => {
  return (
    <>
      <img
        style={{ width: '150px', height: '150px' }}
        src={LinkExpired}
        alt="Link Expired"
      />
      <h2 className={style.contentTitle}>Verification link expired</h2>
      <p className={style.contentDescription}>
        This verification link is no longer valid. Request a new one from your
        profile in the app to continue.
      </p>
      <p className={style.contentDescription}>
        Get started by downloading our {APP_NAME} to your mobile device.
      </p>
    </>
  )
}

export default TokenExpired
